import classes from './ReleasePage.module.css';
import AccordionSideNav from '../../layout/SideNav/AccordionSideNav/AccordionSideNav';
import PageDataList from '../../../store/PageDetailData/PageDetailData';
import AuthContext from '../../../store/auth-context';
import { useContext, Fragment } from 'react';
import { getFilteredPageDataList } from '../../../util/filteredPageData';
import LoadingPage from '../../../components/UI/Loading';
import useValidatePageAccess from '../../../hooks/useValidatePageAccess';

/**
 * 변경 내역 페이지 컴포넌트
 */
const ReleasePage = () => {
  const authCtx = useContext(AuthContext);

  const pageDataList = PageDataList(authCtx.userInfo);
  const pageData = pageDataList.filter(list => list.url === '/release')[0].data;

  // userInfo가 로딩 중일 때는 검증을 지연시킴
  const shouldValidateAccess = authCtx.isLoggedIn && authCtx.userInfo.m_no;

  // isLoggedIn = true 이고 userInfo가 아직 로딩 중일 때는 검증하지 않기 위해 userInfo.m_no = undefined 값으로 전달
  useValidatePageAccess(shouldValidateAccess);

  const solSer = authCtx.userInfo?.sol_ser || '';
  const releaseGroup = pageData.reduce((acc, curr) => {
    const { date } = curr;

    if (acc[date]) acc[date].push(curr);
    else acc[date] = [curr];

    return acc;
  }, {})

  // userInfo가 로딩 중일 때 처리
  if (authCtx.isLoggedIn && !authCtx.userInfo.m_no) {
    return <LoadingPage message='사용자 정보를 불러오는 중...'></LoadingPage>;
  }

  // m_no에 따라 사이드 네비게이션 바에 노출되는 항목들 필터링
  const filteredPageDataList = getFilteredPageDataList(authCtx);
  
  return (
    <>
      <AccordionSideNav data={filteredPageDataList} />
      <div className={classes.container}>
        <h1 className={classes.heading}>API 변경내역</h1>
        {          
          Object.entries(releaseGroup).map(([date, list]) => {            
            return (
              <div key={date} className={classes.section}>
                <div>
                  {
                    list?.filter(li => solSer.includes(li.authorized_sol_ser)|| !li.authorized_sol_ser)?.map((value, i) => {                      
                      return (
                        <Fragment key={i}>
                          <h3>{date}</h3>
                          <div key={i} style={{ paddingBottom: '10px' }}>
                            <div className={classes.url}>
                            {
                              value.method ? 
                              (
                                <div className={classes[value.method.toUpperCase()]}>
                                  <div className={classes.method}>{value.method.toUpperCase()}</div>
                                </div>
                              ) 
                              : ''
                            }
                              <div style={{ paddingLeft:'10px', paddingTop: '2px', textAlign: 'center'}}>{ value.action ? `https://openapi.playauto.io/api${value.action}` : '' }</div>
                            </div>
                            <div className={classes.detail}>
                              {value.detail}
                            </div>
                          </div>
                        </Fragment>
                      );
                    })
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </>
  );
};

export default ReleasePage;